export enum CurrentsDestination {
  S3 = "s3_export", // This comes first because "Amazon S3" comes before "Amplitude" for English localization
  Adobe = "adobe_export",
  Amplitude = "amplitude_export",
  AzureBlob = "azure_blob_export",
  CustomHttp = "custom_http_export",
  Eventbridge = "eventbridge_export",
  GCS = "gcs_export",
  Heap = "heap_export",
  Mixpanel = "mixpanel_export",
  MParticle = "m_particle_export",
  RudderStack = "rudder_stack_export",
  Segment = "segment_dot_com_export",
  Shopify = "shopify_export",
  Tealium = "tealium_export",
  TreasureData = "treasure_data_export",
}

export interface IntegrationsCurrentsIntegrationDataIdResult {
  id: string;
  app_group_id: string;
  company_id: string;
  deleted: boolean;
  enabled: boolean;
  throttled: boolean;
  name: string;
  track_user_behavior_events: boolean;
  track_user_profile_events: boolean;
  integration_type: CurrentsDestination;
  service_type: string;
  user_alias_enabled: null | boolean;
  anon_user_alias_enabled: null | boolean;
  alias_label: null | string;
  anon_alias_label: null | string;
  event_type_configs: {
    users_random_bucket_number_update: boolean;
    users_behaviors_custom_event: boolean;
    users_behaviors_install_attribution: boolean;
    users_behaviors_location: boolean;
    users_behaviors_purchase: boolean;
    users_behaviors_uninstall: boolean;
    users_behaviors_app_first_session: boolean;
    users_behaviors_app_news_feed_impression: boolean;
    users_behaviors_app_session_end: boolean;
    users_behaviors_app_session_start: boolean;
    users_behaviors_liveactivity_push_to_start_token_change: boolean;
    users_behaviors_liveactivity_update_token_change: boolean;
    users_behaviors_pushnotification_token_state_change: boolean;
    users_behaviors_subscriptiongroup_state_change: boolean;
    users_behaviors_subscription_global_state_change: boolean;
    users_campaigns_conversion: boolean;
    users_campaigns_enroll_in_control: boolean;
    users_canvas_conversion: boolean;
    users_canvas_entry: boolean;
    users_canvas_exit_matched_audience: boolean;
    users_canvas_exit_performed_event: boolean;
    users_canvas_experimentstep_conversion: boolean;
    users_canvas_experimentstep_split_entry: boolean;
    users_canvas_costep_send: boolean;
    users_canvas_costep_conversion: boolean;
    contentoptimizer_component_store: boolean;
    users_canvas_sendtodestination_sent: boolean;
    users_canvas_sendtodestination_not_sent: boolean;
    users_messages_email_bounce: boolean;
    users_messages_email_soft_bounce: boolean;
    users_messages_email_click: boolean;
    users_messages_email_mark_as_spam: boolean;
    users_messages_email_open: boolean;
    users_messages_email_send: boolean;
    users_messages_email_delivery: boolean;
    users_messages_email_unsubscribe: boolean;
    users_messages_email_abort: boolean;
    users_messages_email_deferral: boolean;
    users_messages_sms_send: boolean;
    users_messages_sms_carrier_send: boolean;
    users_messages_sms_delivery: boolean;
    users_messages_sms_delivery_failure: boolean;
    users_messages_sms_inbound_receive: boolean;
    users_messages_sms_rejection: boolean;
    users_messages_sms_abort: boolean;
    users_messages_sms_short_link_click: boolean;
    users_messages_inappmessage_click: boolean;
    users_messages_inappmessage_abort: boolean;
    users_messages_inappmessage_impression: boolean;
    users_messages_liveactivity_send: boolean;
    users_messages_liveactivity_outcome: boolean;
    users_messages_pushnotification_bounce: boolean;
    users_messages_pushnotification_open: boolean;
    users_messages_pushnotification_send: boolean;
    users_messages_pushnotification_abort: boolean;
    users_messages_pushnotification_ios_foreground: boolean;
    users_messages_webhook_send: boolean;
    users_messages_webhook_abort: boolean;
    users_messages_webhook_failure: boolean;
    users_messages_contentcard_impression: boolean;
    users_messages_contentcard_click: boolean;
    users_messages_contentcard_dismiss: boolean;
    users_messages_contentcard_send: boolean;
    users_messages_contentcard_abort: boolean;
    users_messages_whatsapp_abort: boolean;
    users_messages_whatsapp_send: boolean;
    users_messages_whatsapp_failure: boolean;
    users_messages_whatsapp_delivery: boolean;
    users_messages_whatsapp_read: boolean;
    users_messages_whatsapp_inbound_receive: boolean;
    users_messages_whatsapp_click: boolean;
    users_messages_featureflag_impression: boolean;
    users_canvasstep_progression: boolean;
    users_profile_update: boolean;
    users_user_delete_request: boolean;
    users_user_orphan: boolean;
  };
  event_field_transformations: {};
  contact_email: string;
  auth_type: number;
  access_key_id: null;
  role_arn: string;
  external_id: string;
  bucket_name: string;
  bucket_region: string;
  topics_dir: string;
  export_anonymous_user_events: boolean;
  account_id: string;
  sse_type: null;
  sse_key_id: null;
  is_sse: boolean;
  created: {
    time: number;
    name: string;
    d_id: string;
  };
  last_edit: {
    time: number;
    name: string;
    d_id: string;
  };
  broken_creds: boolean;
  total_currents_integrations_entitlements: number;
  used_currents_integrations_entitlements: number;
  total_user_behavior_entitlements: number;
  used_user_behavior_entitlements: number;
  total_user_attributes_entitlements: number;
  used_user_attributes_entitlements: number;
}
